import type { RegistrationOptions } from './types';

export type RegistrationSiteOptionsRequest = Readonly<{
  revision: number;
  siteCandidateId: string | null;
}>;

/** Prevents a slower prior site selection from replacing the latest scoped directory. */
export class RegistrationSiteOptionsRequestGate {
  private revision = 0;

  begin(siteCandidateId: string | null): RegistrationSiteOptionsRequest {
    this.revision += 1;
    return { revision: this.revision, siteCandidateId };
  }

  accepts(
    request: RegistrationSiteOptionsRequest,
    options: Pick<RegistrationOptions, 'selectedSiteCandidateId'>,
  ): boolean {
    if (request.revision !== this.revision) return false;
    return request.siteCandidateId === null || options.selectedSiteCandidateId === request.siteCandidateId;
  }
}
